exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-title[data-v-33b6cc70] {\n  font-weight: 500;\n  font-size: 1.75rem;\n  color: rgba(6, 38, 62, 0.74);\n}\n.title-ts-detail[data-v-33b6cc70] {\n  margin-left: -12px;\n  margin-right: -12px;\n}\n.border-encoded[data-v-33b6cc70] {\n  border: 2px solid #cad0d7;\n  border-radius: 5px;\n}\n.date-title[data-v-33b6cc70] {\n  display: inline-flex;\n  justify-content: center !important;\n  font-weight: 500;\n  padding: 4px 0 4px 0;\n  color: rgba(6, 38, 62, 0.74);\n}\n.name-title[data-v-33b6cc70] {\n  font-size: 14px;\n  font-weight: 500;\n  color: #06263e;\n}\n", ""]);

// exports
